(() => {
  'use strict';

  // Capture on the document so the app can insert/recreate its popup later.
  // The native Yes handler and its verification cookie are left to the app.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) ||
        !form.matches('.agp__buttonType__buttonContainer--fail') ||
        !form.closest('.agp__wrapper')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign('https://shakotan-spirit.co.jp/');
  }, true);
})();
